module.exports = __webpack_public_path__ + "img/megaphone-def-icon.072b34b8.svg";